<div class="main">
    <div class="list-container">
        <div class="full main-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <div *ngIf="!loginError" class="full" fxLayout="column" fxLayoutAlign="center center">
                <h2>Loading, please wait</h2>
            </div>
            <div *ngIf="loginError" class="full" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center center">
                <h2>Login failed</h2>
                <p>Please try again or contact Kemppi Support for help</p>
                <br>
                <br>
                <br>

                <code>
                    <small *ngIf="loginError">{{ loginError }}</small>
                </code>
                <code>
                    <small *ngIf="loginErrorDescription"><i>{{ loginErrorDescription }}</i></small>
                </code>
            </div>
        </div>
    </div>
</div>
<!-- ACTIONBAR -->
<ks-actionbar
        [hasCancel]="false"
        [hasSave]="false"
>
